import React from "react";
import { Image, ImageSourcePropType, View, StyleSheet } from "react-native";

interface TposIconProps {
  icon: ImageSourcePropType;
  size?: number;
}

export const TposIcon = ({ icon, size = 25 }: TposIconProps): JSX.Element => {
  const sizeStyle = { height: size, width: size };

  return (
    <View style={styles.iconContainer}>
      <Image
        style={[styles.icon, sizeStyle]}
        resizeMode="contain"
        source={icon}
      />
    </View>
  );
};

export const styles = StyleSheet.create({
  iconContainer: {
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    height: 20,
    width: 20,
  },
});
